import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';

import DPS_svg from '/@/components/bag-quality/dps/assets/DPS.svg?url';
import dekalb_arg_png from '/@/components/bag-quality/dps/assets/dekalb_arg.png?url';
import styles from './styles.module.css';

@autobind
export default class DPS extends Component {
    static propTypes = {
        className: PropTypes.string,
    };

    render() {
        const className = classNames(styles.container, this.props.className);
        return (
            <div className={styles.root}>
                <div className={className}>
                    <div className={styles.containerImgs}>
                        <img className={styles.sizeImgDPS} alt='DPS' src={DPS_svg} />
                        <img className={styles.sizeImgDekalb} alt='Dekalb' src={dekalb_arg_png} />
                    </div>
                    <div className={styles.containerTexts}>{this.props.children}</div>
                </div>
            </div>
        );
    }
}
